module.exports = __webpack_public_path__ + "media/images/tailwind/down-arrow-18db0208cf9fc45d0df08fe228678f17.png";